import { render } from "./DiscountTable.vue?vue&type=template&id=03b74c12&scoped=true"
import script from "./DiscountTable.vue?vue&type=script&lang=js"
export * from "./DiscountTable.vue?vue&type=script&lang=js"

import "./DiscountTable.vue?vue&type=style&index=0&id=03b74c12&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b74c12"]])

export default __exports__